import type { RefundObligationKind, StaleMonriPayment } from "@/types";

export const KIND_LABEL: Record<RefundObligationKind, string> = {
  session: "Seansa",
  enrollment: "Grupna terapija",
  subscription: "Pretplata",
};

export const METHOD_LABEL: Record<string, string> = {
  monri: "Kartica (Monri)",
  bank_transfer: "Uplatnica",
  manual: "Ručni unos",
};

const REASON_LABEL: Record<string, string> = {
  cancelled_paid: "Plaćen termin je otkazan",
  payment_after_cancel: "Uplata stigla nakon otkazivanja",
  payment_after_fail: "Uplata stigla nakon isteka prijave",
  double_charge: "Termin je naplaćen dva puta",
  amount_mismatch: "Naplaćen iznos ne odgovara cijeni",
  ambiguous_approval: "Monri odgovor nije jasan, provjeriti u portalu",
  cycle_cancelled_by_therapist: "Terapeut je otkazao grupnu terapiju",
  cycle_cancelled_therapist_deactivated: "Grupna terapija otkazana jer je terapeut deaktiviran",
  subscription_refunded: "Pretplata je refundirana",
  stale_monri_charged: "Naplaćeno, a rezervacija je otkazana",
  payment_on_refunded_row: "Uplata stigla na već refundiranu pretplatu",
  payment_on_failed_row: "Uplata stigla na istekli link pretplate",
  rejected_missing_enrollment: "Prijava ne postoji, uplata odbijena",
  rejected_already_paid: "Prijava je već plaćena",
  rejected_enrollment_cancelled: "Prijava je otkazana prije uplate",
  rejected_cycle_cancelled: "Grupna terapija je otkazana",
  rejected_therapist_inactive: "Terapeut više nije aktivan",
  rejected_cycle_locked: "Grupna terapija je već počela",
  rejected_cycle_full: "Grupa je popunjena",
};

/** Razlog na jednostavnom bosanskom; nepoznat kod ostaje čitljiv. */
export function reasonLabel(reason: string): string {
  if (REASON_LABEL[reason]) return REASON_LABEL[reason];
  if (reason.startsWith("emergency_request_")) return "Ugašen hitni zahtjev sa uplatom";
  return "Potreban povrat";
}

export const STALE_STATE_LABEL: Record<StaleMonriPayment["referenceState"], string> = {
  cancelled: "Rezervacija otkazana",
  failed: "Plaćanje propalo",
  expired: "Link istekao",
  superseded: "Link zamijenjen ili ugašen",
  pending: "Link još važi",
};
